import { Select } from "antd";
import { useMemo } from "react";
import { useIntl } from "react-intl";
import { useSportConfiguration } from "~hooks/useSportConfiguration";
import type { ColumnComponentProperties } from "../../types";

export const TypeColumn = (properties: ColumnComponentProperties) => {
  const { formatMessage } = useIntl();
  const sportConfiguration = useSportConfiguration();

  const options = useMemo(() => sportConfiguration.fixtureTypes.map((x) => ({ value: x, label: x })), [sportConfiguration]);

  if (properties.editMode) {
    const onChangeHandler = (value: string) =>
      properties.updateFixture({
        fixtureId: properties.fixtureId,
        upsertData: {
          fixtureType: value,
        },
      });

    return (
      <Select
        disabled={properties.isUpdatePending}
        placeholder={formatMessage({
          id: "fixtureListPage.table.column.editMode.fixtureType.placeholder",
        })}
        onChange={onChangeHandler}
        style={{ width: "100%" }}
        defaultValue={properties.value}
        options={options}
      />
    );
  }

  return properties.value;
};
